import gql from 'graphql-tag';

import { RosterIdentityBaseDetails } from '../../../../../graphql/fragments/roster-identity';
import { UserDetails } from '../../../../../graphql/fragments/account';

export const AccountRosterIdentities = gql`
  query accountRosterIdentities(
    $limit: Int = 100
    $offset: Int = 0
    $search_query: String
  ) {
    me {
      id
      roster_identities(
        slice: { limit: $limit, offset: $offset }
        search_query: $search_query
        include_album_folder_albums: true
      ) {
        total
        records {
          id
          ...RosterIdentityBaseDetails
        }
      }
      custom_print_tiers {
        total
      }
    }
  }
  ${RosterIdentityBaseDetails}
  ${UserDetails}
`;
